(() => {
  'use strict';
  if (location.pathname !== '/collections/appliques-murales' || window.__efCollectionV5) return;
  window.__efCollectionV5 = true;
  const key = 'efCollectionV5';
  const pageKey = () => location.pathname + location.search;
  let context = {url:pageKey(), pages:[], departure:null};
  let restoring = false, attempted = false, live;
  const grid = () => document.getElementById('collection');
  const productPath = value => { try { const u=new URL(value,location.origin); return u.origin===location.origin&&u.pathname.startsWith('/products/')?u.pathname:null; } catch (_) { return null; } };
  const cards = () => [...(grid()?.children || [])].filter(el=>el.querySelector('figure a[href*="/products/"]'));
  const cardFor = path => cards().find(el=>[...el.querySelectorAll('figure a[href]')].some(a=>productPath(a.href)===path));
  function save() {
    try { history.replaceState({...history.state,[key]:context},'',location.href); } catch (_) {}
  }
  function currentAnchor() {
    const card=cards().find(el=>el.getBoundingClientRect().bottom>130);
    if (!card) return null;
    return {path:productPath(card.querySelector('figure a[href]').href),offset:Math.round(card.getBoundingClientRect().top),scrollY:window.scrollY};
  }
  function countCards(announce=false) {
    const g=grid();if(!g)return;
    /* EF 25/09/2026 : compteur visible retire (decision de Timothee) ; l'annonce lecteur d'ecran est conservee. */
    const old=g.nextElementSibling;if(old?.matches('.ef-collection-count'))old.remove();
    const total=cards().length;
    const text=total+' '+(total>1?'pièces présentées':'pièce présentée');
    if(announce) {
      if(!live){live=document.createElement('p');live.className='screen-reader-text';live.setAttribute('role','status');document.body.append(live);}
      live.textContent=text;
    }
  }
  function safePage(value) {
    try { const u=new URL(value,location.origin);return u.origin===location.origin&&u.pathname===location.pathname?u.href:null; } catch(_){return null;}
  }
  function waitForLoad(button) {
    return new Promise((resolve,reject)=>{
      let timer;
      const clean=()=>{clearTimeout(timer);document.removeEventListener('ef:collection-page-loaded',done);document.removeEventListener('ef:collection-page-error',fail);};
      const done=()=>{clean();resolve();};
      const fail=()=>{clean();reject(new Error('Collection page could not be restored'));};
      document.addEventListener('ef:collection-page-loaded',done,{once:true});
      document.addEventListener('ef:collection-page-error',fail,{once:true});
      timer=setTimeout(fail,15000);
      button.click();
    });
  }
  async function restore() {
    if(attempted||restoring||!grid()||!window.__efCollectionLoaderReady)return;
    attempted=true;
    const saved=history.state?.[key];
    if(!saved||saved.url!==pageKey()||!Array.isArray(saved.pages)) {save();return;}
    context={url:saved.url,pages:saved.pages.filter(safePage).slice(0,12),departure:saved.departure};
    if(!context.departure?.path||!productPath(context.departure.path))return;
    restoring=true;grid().setAttribute('aria-busy','true');
    const pages=[...context.pages];
    try {
      const required=pages.length;
      if(!cardFor(context.departure.path)||cards().length<=24&&required) {
        for(const url of pages) {
          const target=new URL(url);
          const button=[...document.querySelectorAll('#load-more-button[data-next],#load-more-button[data-prev]')].find(a=>{
            const next=new URL(a.href);return next.pathname===target.pathname&&next.searchParams.get('page')===target.searchParams.get('page');
          });
          if(button)await waitForLoad(button);
        }
      }
      const card=cardFor(context.departure.path);
      if(card) {
        const offset=Number.isFinite(context.departure.offset)?context.departure.offset:130;
        window.scrollTo({top:Math.max(0,window.scrollY+card.getBoundingClientRect().top-offset),behavior:'instant'});
      }
    } catch(_) {
      if(!live){live=document.createElement('p');live.className='screen-reader-text';live.setAttribute('role','status');document.body.append(live);}
      live.textContent='La suite de la collection reste accessible avec le bouton Afficher plus de produits.';
    } finally {restoring=false;context.departure=null;grid()?.removeAttribute('aria-busy');countCards();save();}
  }
  document.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target:null;
    const a=target?.closest('#collection a[href]');
    if(!a||event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const path=productPath(a.href), card=a.closest('#collection > li');
    if(!path||!card)return;
    const originPath=productPath(card.querySelector('figure a[href]')?.href);
    context.departure={path:originPath||path,visitedPath:path,offset:Math.round(card.getBoundingClientRect().top),scrollY:window.scrollY};save();
  },true);
  document.addEventListener('ef:collection-page-loaded',event=>{
    const url=safePage(event.detail?.url);if(url&&!context.pages.includes(url))context.pages.push(url);
    countCards(!restoring);save();
  });
  document.addEventListener('ef:collection-filter-before',()=>{context.departure=currentAnchor();save();});
  document.addEventListener('ef:collection-filter-after',()=>{context={url:pageKey(),pages:[],departure:null};attempted=true;countCards(true);save();});
  document.addEventListener('ef:collection-loader-ready',restore);
  window.addEventListener('popstate',()=>{if(pageKey()!==context.url)location.reload();});
  window.addEventListener('pageshow',event=>{if(event.persisted){context.departure=null;countCards();save();return;}restore();});
  countCards();restore();
})();
